module.exports = __webpack_public_path__ + "static/media/student profile.91c2005a.svg";